module.exports = __webpack_public_path__ + "files/cfa9a29dd324138db2453d913cc86478.png";